export const getCleanStringWithCommas = (dirtyString: string) => {
  const cleanString = dirtyString.replace(/[^a-zA-Z0-9, ]/g, '');
  return cleanString;
};
